import { useSelector } from 'react-redux';
import { getShowConfirmationPage } from '../../../selectors/tools';
import DTCancelReturnThenSendMacro from '../NodeGroups/DTCopyTextSendMacro/DTCancelReturnThenSendMacro/DTCancelReturnThenSendMacro';

const CancelReturnThenSendMacro = () => {
  const showConfirmationPage = useSelector(getShowConfirmationPage);

  return <DTCancelReturnThenSendMacro showConfirmation={showConfirmationPage} message={'Return has been cancelled.'} />;
};

export default CancelReturnThenSendMacro;
